import { H2 } from "@dgs/core";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { config } from "..//config/config";
import { ImageAnchorButton } from "../shared/ui/ImageAnchorButton";

const Container = styled.div`
	${({ theme }) => theme.auth.container}
`;

const AuthCard = styled.div`
	${({ theme }) => theme.auth.card};
`;

export const Header = styled(H2)`
	${({ theme }) => theme.auth.header};
`;

export const Description = styled.div`
	${({ theme }) => theme.auth.description};
`;

export const AppButtons = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing(2)};
	justify-content: center;
	align-items: center;
	padding-top: ${({ theme }) => theme.spacing(4)};

	${({ theme }) => theme.breakpoints.tablet} {
		flex-direction: row;
	}
`;

export const AppPasswordResetSuccessPage: FC = () => {
	const { t } = useTranslation();

	const [isAndroid, isIOS, isNeither] = useMemo(() => {
		const isAndroid = navigator.userAgent.includes("android");
		const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

		return [isAndroid, isIOS, !isAndroid && !isIOS];
	}, []);

	return (
		<Container>
			<AuthCard>
				<Header>{t("Password reset successful")}</Header>
				<Description>{t("You can click the button below, to get the app now.")}</Description>
				<AppButtons>
					{(isAndroid || isNeither) && (
						<ImageAnchorButton
							title={t("Google Play")}
							src="google_play_badge.svg"
							href={config.playStoreLink}
							target="_blank"
						>
							{t("Google Play")}
						</ImageAnchorButton>
					)}
					{(isIOS || isNeither) && (
						<ImageAnchorButton
							title={t("App Store")}
							src="app_store_badge.svg"
							href={config.appStoreLink}
							target="_blank"
						>
							{t("App Store")}
						</ImageAnchorButton>
					)}
				</AppButtons>
			</AuthCard>
		</Container>
	);
};
